export const ar = {
  "Dashboard": "لوحة القيادة",
  "Rent Contract": "عقد الإيجار",
  "Customer": "عميل",
  "Vehicles": "المركبات",
  "Vehicles Care": "العناية بالمركبات",
  "Staff": "طاقم عمل",
  "Reports": "التقارير",
  "Accounts": "الحسابات",
  "Settings": "إعدادات",
  "Logout": "تسجيل الخروج",
  "English": "إنجليزي",
  "Arabic": "عربي",
  // VEHICLE PAGES
  "Vehicle Information": "معلومات المركبة",
  "Drag and drop or click here to select file": "قم بالسحب والإفلات أو انقر هنا لتحديد الملف",
  "Car Name": "اسم السيارة",
  "VIN Number": "رقم VIN",
  "Plate Number": "رقم اللوحة",
  "Plate Letters": "رسائل لوحة",
  "Insurance Type": "نوع التأمين",
  "Insurance Country": "بلد التأمين",
  "Car Factory": "مصنع سيارات",
  "Year of Manufacture": "سنة الصنع",
  "Insurance Company Name": "اسم شركة التأمين",
  "License Validity": "صلاحية الترخيص",
  "License Expiry Date": "تاريخ انتهاء الترخيص",
  "Insurance Policy Number": "رقم بوليصة التأمين",
  "Vehicle Owner": "مالك المركبة",
  "Car Color": "لون السيارة",
  "Kilometer Reading": "قراءة الكيلومتر",
  "Miles Reading": "مايلز ريدينغ",
  "Car's Conditions": "ظروف السيارة",
  "Kilometers for Next Maintenance": "كيلومترات للصيانة القادمة",
  "Current Readings": "القراءات الحالية",
  "Daily Rental Cost": "تكلفة الإيجار اليومية",
  "Weekly Rental Cost": "تكلفة الإيجار الأسبوعية",
  "Monthly Rental Cost": "تكلفة الإيجار الشهري",
  "The Cost of the Daily Additional KM": "تكلفة الكيلومترات الإضافية اليومية",
  "Day/Week Rental Cost": "تكلفة الإيجار يوم / أسبوع",
  "Day/Month Rental Cost": "تكلفة الإيجار يوم / شهر",
  "Submit": "يُقدِّم",
  "Vehicle Items": "عناصر المركبة",

  "All Vehicles": "جميع المركبات",
  "Vehicle Under Maintenance": "مركبة تحت الصيانة",
  "Generate Report": "إنشاء تقرير",
  "New Vehicle": "مركبة جديدة",
  "More details": "مزيد من التفاصيل",
  "Rent It Now": "استأجرها الآن",
  "Transfer To Maintenance": "نقل إلى الصيانة",
  "Delete Car": "حذف السيارة",

  "Total Contracts": "إجمالي العقود",
  "Total Contract Amounts": "إجمالي مبالغ العقد",
  "Total Vehicle Expenses": "إجمالي مصاريف المركبات",
  "Total Unpaid Amounts": "إجمالي المبالغ غير المدفوعة",
  "Vehicle Plate": "لوحة المركبة",
  "Vehicle Name": "اسم المركبة",
  "Vehicle Insurance Company Name": "اسم شركة تأمين المركبات",
  "VIN Number": "رقم",
  "Insurance Type": "نوع التأمين",
  "Model Year": "سنة الموديل",
  "Insurance Policy Number": "رقم بوليصة التأمين",
  "Manufacturing": "تصنيع",
  "Vehicle Owner": "مالك المركبة",
  "License Validity": "صلاحية الترخيص",
  "Vehicle Colour": "لون المركبة",
  "License Expiry Date": "تاريخ انتهاء الترخيص",




  // COMMAN 
  "Edit": "يحرر",
}